import { render, staticRenderFns } from "./CompanyNotice.vue?vue&type=template&id=568fca30&scoped=true"
import script from "./CompanyNotice.vue?vue&type=script&lang=js"
export * from "./CompanyNotice.vue?vue&type=script&lang=js"
import style0 from "./CompanyNotice.vue?vue&type=style&index=0&id=568fca30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fca30",
  null
  
)

export default component.exports